import React from 'react';

interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
}

export const SectionTag: React.FC<SectionTagProps> = ({ children, className = '', dark = false }) => {
  return (
    <div className={`inline-flex items-center space-x-2 mb-8 ${className}`}>
      <span className={`w-2 h-2 rounded-full ${dark ? 'bg-white' : 'bg-red-600'}`}></span>
      <span className={`text-[10px] uppercase tracking-[0.2em] font-bold ${dark ? 'text-white' : 'text-gray-400'}`}>
        {children}
      </span>
    </div>
  );
};